var State = {
  editor_opened: false
}

export default State